import { render, staticRenderFns } from "./VTableHeaders.vue?vue&type=template&id=65dd9850"
import script from "./VTableHeaders.vue?vue&type=script&lang=js"
export * from "./VTableHeaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports